import React from 'react';
import {
    IGetExpertsProps,
    EditExperts,
    ISubmitExpertsProps,
} from 'components';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { AssignExpertsToExam } from '../../api/ApiClient';

const EditExpertsContainer = ({
    getAvailableExperts,
    examId,
    qualificationId,
    assignExpertsToExam,
    apiError,
    onPush,
    fetchExamDetailsAsync,
    examDetails,
    experts,
    loading,
}: Props) => {
    const getExperts = async (data: IGetExpertsProps) => {
        await getAvailableExperts({
            onlyEmployees: !!data.onlyQecEmployees,
            qualificationId,
        });
    };

    const handleAcceptExpert = async (data: ISubmitExpertsProps) => {
        await assignExpertsToExam({
            examId,
            body: new AssignExpertsToExam({
                invitedExpertIds: data.expertIds,
                committeeChairmanId: data.chairmanId,
            }),
        });
        if (apiError) return;
        onPush(`/exam/${examId}`);
    };

    const getExamDraft = async () => {
        await fetchExamDetailsAsync(examId);
    };

    const handleClickCancel = () => {
        onPush(`/exam/${examId}`);
    };

    return (
        <EditExperts
          experts={experts}
          getExperts={getExperts}
          submitSelectExperts={handleAcceptExpert}
          handleClickCancel={handleClickCancel}
          examDetails={examDetails}
          getExamDraft={getExamDraft}
          loading={loading}
          apiError={apiError}
        />
    );
};

const mapState = (state: IRootState) => ({
    examDetails: state.exam.examDetails,
    experts: state.experts.availableExpertsList,
    apiError: state.errors.error,
    loading: Boolean(state.loading.effects.exam.assignExpertsToExamAsync) || Boolean(state.loading.models.experts),
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getAvailableExperts: dispatch.experts.getAvailableExpertsAsync,
    assignExpertsToExam: dispatch.exam.assignExpertsToExamAsync,
    fetchExamDetailsAsync: dispatch.exam.fetchExamDetailsAsync,
});

export default connect(mapState, mapDispatch)(EditExpertsContainer);

interface OwnProps {
    examId: string;
    qualificationId: string;
}

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch> & OwnProps;
